// The thumbnail bytes-PUT needs its version row to exist first. Extracted pure
// (asset + row-creator in, target out) so the create-then-PUT ordering is
// unit-testable without React or Uppy.
export const resolveThumbnailTarget = async ({ asset, createAsset, storageBase }) => {
  const target = asset || (await createAsset())

  return {
    target,
    url: `${storageBase}/api/v1/file-content/${target.id}/thumbnail-custom`,
    method: 'PUT',
  }
}
